export const NODE_MEMORY_LOAD_REQUEST = 'NODE_MEMORY_LOAD_REQUEST';
export const NODE_MEMORY_LOAD_SUCCESS = 'NODE_MEMORY_LOAD_SUCCESS';
export const NODE_MEMORY_LOAD_FAILURE = 'NODE_MEMORY_LOAD_FAILURE';

export const NODE_MEMORY_PARTIAL = 'NODE_MEMORY_PARTIAL';
